import type { RegistrationUserDataPlugin } from '@adornis/buchungsheld-db/db-plugins.js';
import type { BHTranslationDictionary } from '@adornis/buchungsheld-db/translations/translation.js';
import type { GenericFieldFormController } from '@adornis/cms/client/generic-field-formcontroller.js';
import '@adornis/internationalization/client/language-picker/x-country-picker.js';
import '@adornis/internationalization/client/x-tel-input.js';
import { globalLanguageSubject } from '@adornis/translation-core/client/languageSubject.js';
import type { TranslationController } from '@adornis/translation-core/client/translation-controller.js';
import { html } from 'lit';
import { CsjensblanksDepartments, type CsjensblanksStammdaten } from '../stammdaten/csjensblank-stammdaten-plugin.js';

export const csjensblankRegistrationUserDataPlugin: RegistrationUserDataPlugin<CsjensblanksStammdaten> = {
  id: 'registration::user-data::csjensblank',
  type: 'registration::user-data',
  extraUserFields: [['dateOfBirth']],
  render: (
    stContr: GenericFieldFormController<CsjensblanksStammdaten>,
    translationController: TranslationController<BHTranslationDictionary>,
  ) => {
    const genericFieldOption = (fieldName: string) =>
      ({
        placeholder: translationController.translate('csjensblank', 'field', fieldName as any) as string,
        placeholderMode: 'static-floating',
      } as const);

    // components

    const countryPicker = (key: Parameters<typeof stContr.field>[0]) => html`
      <x-country-picker
        showflag
        language=${globalLanguageSubject.getValue()}
        placeholder=${translationController.translate('csjensblank', 'field', key as any) + '*'}
        ${stContr.field(key)}
      >
      </x-country-picker>
    `;

    return html`
      <x-flex space="lg">
        <!-- personal data -->
        <x-flex space="sm">
          ${stContr.genericField(['matriklNr'], genericFieldOption('matriklNr'))}
          ${stContr.genericField(['gender'], genericFieldOption('gender'))}

          <!-- nationality -->
          ${countryPicker('nationality')}

          <!-- country of birth -->
          ${countryPicker('countryOfBirth')}

          <!-- uni qualification country -->
          ${countryPicker('uniQualificationCountry')}
        </x-flex>

        <!-- studium -->
        <x-flex space="sm">
          <tr-h4> Studium </tr-h4>
          <tr-dropdown-selection
            ${stContr.field('semester')}
            placeholder=${translationController.translate('csjensblank', 'field', 'semester') + '*'}
            .selectables=${[
              1,
              2,
              3,
              4,
              5,
              6,
              7,
              8,
              9,
              10,
              11,
              12,
              13,
              14,
              15,
              16,
              17,
              18,
              19,
              20,
              'mehr als 20',
              'Studium bereits abgeschlossen',
            ].map(i => i.toString())}
          ></tr-dropdown-selection>

          ${stContr.genericField(['courseOfStudy'], genericFieldOption('courseOfStudy'))}

          <tr-dropdown-selection
            ${stContr.field('department')}
            placeholder=${translationController.translate('csjensblank', 'field', 'department') + '*'}
            .selectables=${CsjensblanksDepartments}
          ></tr-dropdown-selection>

          ${stContr.genericField(['desiredDegree'], genericFieldOption('desiredDegree'))}
          ${stContr.genericField(
            ['ichMchteberDenNewsletterberAngeboteInformiertWerden'],
            genericFieldOption('ichMchteberDenNewsletterberAngeboteInformiertWerden'),
          )}
        </x-flex>
      </x-flex>
    `;
  },
};
